// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"d17b89c6f7308b8b72f8","293":"8aa1e6bc995b4b21d227","518":"494b7682df7ce26f92a5","779":"31d5cdc8766a20a107b2"}[chunkId] + ".js";
};